
import React from 'react';
import { AppStep } from '../types.ts';
import { Upload, Microscope, Sparkles, Code, FileCode, Play } from 'lucide-react';

interface StepperProps {
  currentStep: AppStep;
}

const steps = [
  { id: AppStep.UPLOAD, icon: Upload, label: "Upload" },
  { id: AppStep.EXTRACTION, icon: Microscope, label: "Engine 1" },
  { id: AppStep.DESIGN, icon: Sparkles, label: "Engine 2" },
  { id: AppStep.GENERATION, icon: Code, label: "Engine 3" },
  { id: AppStep.CODE_VIEW, icon: FileCode, label: "Code" },
  { id: AppStep.PREVIEW, icon: Play, label: "Preview" },
];

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  return (
    <div className="w-full flex justify-between items-center relative mb-12">
      {/* Connector Line */}
      <div className="absolute top-1/2 left-0 w-full h-0.5 bg-slate-800 -translate-y-1/2 -z-10" />
      
      {steps.map((step) => {
        const Icon = step.icon;
        const isActive = currentStep === step.id;
        const isCompleted = currentStep > step.id;
        
        return (
          <div key={step.id} className="flex flex-col items-center gap-2">
            <div className={`
              w-12 h-12 rounded-full flex items-center justify-center transition-all duration-500 border-2
              ${isActive ? 'bg-indigo-600 border-indigo-400 scale-110 shadow-lg shadow-indigo-600/50' : ''}
              ${isCompleted ? 'bg-emerald-600 border-emerald-400' : ''}
              ${!isActive && !isCompleted ? 'bg-slate-900 border-slate-700' : ''}
            `}>
              <Icon size={20} className={`${isActive || isCompleted ? 'text-white' : 'text-slate-500'}`} />
            </div>
            <span className={`text-xs font-semibold tracking-tighter ${isActive ? 'text-white' : 'text-slate-500'}`}>
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
